import {applyMiddleware, combineReducers, createStore} from 'redux';
import thunk from 'redux-thunk';
import authReducer from './auth/reducer';
import {composeWithDevTools} from 'redux-devtools-extension';
import translationReducer from './translation/reducer';
import statusReducer from './status/reducer';
import contentReducer from './content/reducer';
import feedbackReducer from './feedback/reducer';
import mediaReducer from './media/reducer';
import dialogueReducer from './dialogue/reducer';
import articleReducer from './article/reducer';
import journalReducer from './journal/reducer';
import journalStatsReducer from './journal-stats/reducer';
import reviewReducer from './review/reducer';
import chatroomReducer from './chatroom/reducer';
import cmServiceReducer from './cm-service/reducer';
import searchReducer from './search/reducer';
import trainingsReducer from './trainings/reducer';
import exerciseReducer from './exercise/reducer';
import statisticsReducer from './staistics-dashboard/reducer';

export const rootReducer = combineReducers({
  auth: authReducer,
  translation: translationReducer,
  status: statusReducer,
  content: contentReducer,
  feedback: feedbackReducer,
  media: mediaReducer,
  dialogue: dialogueReducer,
  article: articleReducer,
  journal: journalReducer,
  journal_stats: journalStatsReducer,
  review: reviewReducer,
  chatroom: chatroomReducer,
  cm_service: cmServiceReducer,
  search: searchReducer,
  trainings: trainingsReducer,
  exercise: exerciseReducer,
  statistics_dashboard: statisticsReducer
});

const middleware = process.env.NODE_ENV === 'production'
  ? applyMiddleware(thunk)
  : composeWithDevTools(
    applyMiddleware(thunk)
  );

const store = createStore(
  rootReducer, {}, middleware
);

export default store;
